import { useRef, useMemo } from 'react';
import { css } from '@eti/styles';
import { Stack, vars } from '@etg/wings';
import { useMediaQuery } from 'usehooks-ts';
import { getCabins } from '../utils/cabin';
import SeatMapCabin from './SeatMapCabin';
import SeatCharacteristicsToggleButton from './seatCharacteristics/components/SeatCharacteristicsToggleButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const seatMapCabinLayoutWrapper = css`
  background-color: ${vars.colors.page.background.primary};
  max-height: calc(94vh - 200px);
  overflow-y: scroll;
  padding-bottom: 25%;
  position: relative;

  @media (min-width: 1200px) {
    padding-bottom: 8px;
  }
`;
const toggleButtonWrapper = css`
  bottom: 0;
  padding: 12px 0;
  position: sticky;
  width: 100%;
  z-index: 10;
`;
const generateKey = index => `cabin_${index}`;
const SeatMapCabinLayout = _ref => {
  let {
    currentSegment,
    selectedDeck = {
      label: 'mainDeck',
      value: 'mainDeck'
    },
    activeSegment,
    onChange,
    seatTravelers,
    seatCharacteristics,
    travelerSeatSelectionsBySegment,
    onClose,
    onSaveAndContinue,
    shouldShowSummary
  } = _ref;
  const deckRef = useRef(null);
  const isDesktop = useMediaQuery(`(min-width: 1200px)`);
  const cabins = useMemo(() => getCabins(currentSegment, selectedDeck), [currentSegment, selectedDeck]);
  return /*#__PURE__*/_jsxs("div", {
    className: seatMapCabinLayoutWrapper,
    "data-testid": "seatMap-cabinLayout",
    ref: deckRef,
    children: [(cabins === null || cabins === void 0 ? void 0 : cabins.length) > 0 && cabins.map((cabin, index) => /*#__PURE__*/_jsx(SeatMapCabin, {
      activeSegment: activeSegment,
      carrier: currentSegment === null || currentSegment === void 0 ? void 0 : currentSegment.carrier,
      onChange: onChange,
      onClose: onClose,
      onSaveAndContinue: onSaveAndContinue,
      seatTravelers: seatTravelers,
      shouldShowSummary: shouldShowSummary,
      travelerSeatSelectionsBySegment: travelerSeatSelectionsBySegment,
      ...cabin
    }, generateKey(index))), !isDesktop && /*#__PURE__*/_jsx(Stack, {
      className: toggleButtonWrapper,
      children: /*#__PURE__*/_jsx(SeatCharacteristicsToggleButton, {
        seatCharacteristics: seatCharacteristics
      })
    })]
  });
};
export default SeatMapCabinLayout;
//# sourceMappingURL=SeatMapCabinLayout.js.map